/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./uploader-dialog.vue?vue&type=template&id=51fae332&"
import script from "./uploader-dialog.vue?vue&type=script&lang=ts&"
export * from "./uploader-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./uploader-dialog.vue?vue&type=style&index=0&id=51fae332&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports